<template>
    <v-menu
            attach=".ex-filter-menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="500"
            transition="slide-y-transition"
            offset-y
            class="ex-search-menu "
    >
      <v-btn
              slot="activator"
              v-ripple="false"
              class="g-menu-btn"
      >
        <i class="icon-menu"></i>
      </v-btn>
      <v-layout column wrap class="ex-main-search-filters">
          <v-radio-group v-model="row1" row class="ex-display-none">
              <v-radio
                      class="ex-radio-button"
                      aria-selected="true"
                      label="Givers"
                       value="radio-1">

              </v-radio>
              <v-radio
                      class="ex-radio-button"
                      label="Receivers"
                       value="radio-2">

              </v-radio>
          </v-radio-group>
          <hr class="mb-10 ex-display-none">
          <v-layout row wrap class="p-15">
              <v-flex
                      v-for="category in categories"
                      :key="category.id"
                      xs6 md6 lg4
                      class="resp-search"
              >
                  <v-card class="ex-categories-card" style="height: 100%">
                      <v-list class="main-search-title">
                          <v-list-tile>
                              <span @click="selectCategory(category)">{{ category.displayInfo.name }}</span>
                              <v-icon v-if="category.subcategories.length > 4" @click="collapse(category.id)" :class="['material-icons', showCatId === category.id ? 'more-arrow' : '']" color="#c5cfd7" flat>
                                keyboard_arrow_down
                              </v-icon>
                          </v-list-tile>
                      </v-list>
                      <div class="main-search-filters">
                          <v-list
                                  v-for="(subCheckbox, index) in category.subcategories"
                                  :key="subCheckbox.id"
                          >
                              <v-list-tile v-if="index < 4" @click="selectCategory(category, subCheckbox.id)">
                                  <v-subheader>{{subCheckbox.displayInfo.name}}</v-subheader>
                              </v-list-tile>
                              <v-list-tile v-else-if="showCatId === category.id"  @click="selectCategory(category, subCheckbox.id)">
                                  <v-subheader>{{subCheckbox.displayInfo.name}}</v-subheader>
                              </v-list-tile>
                          </v-list>
                      </div>
                  </v-card>
              </v-flex>
          </v-layout>
          <v-layout class="d-flex column">
              <hr>
              <v-flex>
                  <v-btn
                          class="btn-lg ex-transparent-button-link"
                          @click="allCategories()">
                      {{$t('categories.all_categories')}}
                      <i class="icon-angle-down-18"></i>
                  </v-btn>
              </v-flex>
          </v-layout>
      </v-layout>
    </v-menu>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from '../../event-bus'

export default {
  data: () => ({
    showCatId: null,
    menu: false,
    row1: null
  }),
  computed: {
    ...mapState({
      categories: state => state.categories.list,
      languages: state => state.common.languages
    })
  },
  methods: {
    allCategories () {
      this.menu = false
      EventBus.$emit('set-default-params')
      if (['products', 'product'].includes(this.$route.name)) {
        this.$router.push({name: 'products', query: {page: 1, limit: 8}})
      }
      if (['Needs', 'need'].includes(this.$route.name)) {
        this.$router.push({name: 'Needs'})
      }
    },
    selectCategory (category, subCatId) {
      this.menu = false
      let query = {}
      if (category) {
        query.cat = category.id
      }
      if (subCatId) {
        query.filter = [subCatId]
      }
      this.$store.dispatch('categories/setMainSearchData', query)

      if (this.$route.name !== 'products') {
        this.$router.push({ name: 'products', query: {cat: query.cat, filter: `${query.filter}`} })
      } else if (this.$route.name === 'Needs') {
        this.$router.push({ name: 'Needs' })
      } else {
        EventBus.$emit('select-category', {category: category, filter: query.filter || []})
      }
    },
    collapse (subCatId) {
      if (this.showCatId === subCatId) {
        this.showCatId = null
      } else {
        this.showCatId = subCatId
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    @import "../../assets/sass/desktop/header.scss";
    .collapse-button {
        position: absolute;
        bottom: 5px;
        right: 0;
    }
  .material-icons {
    &.more-arrow {
      transform: rotate(180deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/categories/mainSearch.vue